import api from "@/services/api";
import store from "@/store";

const state = { renewalPayments: [] };
const getters = { renewalPayments: (s) => s.renewalPayments };
const mutations = {
  SET_RENEWAL_PAYMENTS(state, renewalPayments) {
    state.renewalPayments = renewalPayments;
  },
};

const actions = {
  async getRenewalPayments({ commit }) {
    try {
      const user = store.getters["auth/user"];
      if (!user || user.userType !== "admin") throw new Error("Unauthorized");

      const res = await api.get("/renewal-payments");
      commit("SET_RENEWAL_PAYMENTS", res.data);
    } catch (error) {
      console.error("Error fetching renewal payments:", error.message);
      throw error;
    }
  },

  async getRenewalPaymentById(_, id) {
    try {
      const res = await api.get(`/renewal-payments/${id}`);
      return res.data;
    } catch (error) {
      console.error("Error fetching renewal payment:", error.message);
      throw error;
    }
  },
};

export default { namespaced: true, state, getters, actions, mutations };
